<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="អ្នកដឹកជញ្ជូនទាំងអស់" name="first"></el-tab-pane>
			<el-tab-pane label="បង្កើតអ្នកដឹកជញ្ជូនថ្មី" name="second"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>ស្វែងរកតាមរយៈ ឈ្មោះ លេខទូរស័ព្ទ ឬ ID</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-30">
					<md-field>
						<label>ស្ថានភាព (ទាំងអស់)</label>
						<md-select placeholder="ស្ថានភាព (ទាំងអស់)" v-model="search.status">
							<md-option value="">ទាំងអស់</md-option>
							<md-option value="act">ដំណើរការ</md-option>
							<md-option value="nat">មិនដំណើរការ</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-size-30">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">ស្វែងរក
					</md-button>
				</div>
			</div>

			<md-table v-if="driverList.length > 0">
				<md-table-row>
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>លេខ​ ID</md-table-head>
					<md-table-head>ឈ្មោះ</md-table-head>
					<md-table-head>លេខទូរស័ព្ទ</md-table-head>
					<!-- <md-table-head>កំណត់ចំណាំ</md-table-head> -->
					<md-table-head>ថ្ងៃបង្កើត</md-table-head>
					<md-table-head>ស្ថានភាព</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(driver, index) in driverList">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell>
						<img src="@/assets/img/default-member.png" style="width: 34px; margin-right:5px">
						{{ driver.hash_id }}
					</md-table-cell>
					<md-table-cell>{{ driver.name }}</md-table-cell>
					<md-table-cell>{{ driver.phone }}</md-table-cell>
					<md-table-cell>{{ config.datelify(driver.created_date) }}</md-table-cell>
					<md-table-cell>
						<span class="green" v-if="driver.status == 'act'">{{config.getStatus(driver.status)}}</span>
						<span class="late" v-if="driver.status == 'nac'">{{config.getStatus(driver.status)}}</span>
					</md-table-cell>
					<md-table-cell>
						<router-link :to="'/drivers/detail/' + driver.hash_id">
							<md-button class="md-just-icon md-simple md-primary">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">បង្ហាញបន្ថែម</md-tooltip>
							</md-button>
						</router-link>
						<router-link :to="'/drivers/edit/' + driver.hash_id">
							<md-button class="md-just-icon md-simple md-info">
								<md-icon>edit</md-icon>
								<md-tooltip md-direction="top">កែប្រែ</md-tooltip>
							</md-button>
						</router-link>
						<md-button class="md-just-icon md-simple md-danger" @click="activate(driver.id, driver.status)">
							<span v-if="driver.status == 'act'">
								<md-icon>block</md-icon>
								<md-tooltip md-direction="top">ផ្អាកដំណើរការ</md-tooltip>
							</span>
							<span v-else>
								<md-icon>done</md-icon>
								<md-tooltip md-direction="top">ដាក់ឱ្យដំណើរការ</md-tooltip>
							</span>
						</md-button>
						<template v-if="$store.state.authentication.account_type == 'sa'">
							<md-button class="md-just-icon md-simple md-danger" @click="deleteDriver(driver.id)">
								<md-icon>close</md-icon>
								<md-tooltip md-direction="top">លុបចេញ</md-tooltip>
							</md-button>
						</template>
					</md-table-cell>
				</md-table-row>
			</md-table>

			<h4 class="text-center" v-if="driverList.length == 0 && loadMore == true">មិនមានទិន្នន័យ</h4>
			<!-- <div class="places-buttons text-center" v-if="loadMoreCompanyButton" >
				<md-button class="md-primary" @click="getCompany(companyList.length, false)">បង្ហាញបន្ថែម</md-button>
			</div> -->
		</div>

		<div v-if="tabName == 'second'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានអ្នកដឹកជញ្ជូន</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100 text-right">
						<span class="late">* តម្រូវឱ្យបំពេញ</span>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>ឈ្មោះអ្នកដឹកជញ្ជូន *</label>
								<md-input type="text" v-model="driver.name"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>លេខទូរស័ព្អអ្នកដឹកជញ្ជូន *</label>
								<md-input type="text" v-model="driver.phone"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>ពាក្យសំងាត់ *</label>
								<md-input type="password" v-model="driver.password">
								</md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>បញ្ជាក់ពាក្យសំងាត់ *</label>
								<md-input type="password" v-model="driver.confirm_password">
								</md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>កំណត់ចំណាំផ្សេងៗ</label>
								<md-input type="text" v-model="driver.note">
								</md-input>
							</md-field>
						</div>
					</div>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានសង្ខេប</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell style="width: 50%;">ឈ្មោះអ្នកដឹកជញ្ជូន</md-table-cell>
								<md-table-cell style="width: 5px">:</md-table-cell>
								<md-table-cell>
									<span v-if="String(driver.name).length > 0">{{driver.name}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>លេខទូរស័ព្ទ</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(driver.phone).length > 0">{{driver.phone}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>កំណត់ចំណាំ</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(driver.note).length > 0">{{driver.note}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
				<div class="md-layout-item md-size-100 text-right">
					<md-button class="md-raised md-primary" @click="postDriver()">បង្កើត</md-button>
				</div>
			</div>

		</div>

		<md-dialog-confirm :md-active.sync="deleteDialog" md-title="តើអ្នកពិតជាចង់លុបអ្នកដឹកនេះពិតមែនទេ ?"
			md-content="ព័ត៌មានរបស់អ្នកដឹកនឹងត្រូវបានលុបចេញពីបញ្ជីជារាងរហូត។" md-confirm-text="លុប" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="deleteDriver" />
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			// this.getTransaction();
			this.searchHandler();
		},
		data() {
			return {
				tabName: "first",
				loaded: false,
				search: {
					text: "",
					status: ""
				},
				deleteID: "",
				deleteDialog: false,
				driver: {
					valid: false,
					name: "",
					phone: "",
					password: "",
					confirm_password: "",
					note: ""
				},
				loadMore: true,
				driverList: []
			}
		},
		methods: {
			getSettings() {
				this.$http.get(this.config.api + "/admin/setting/data/get_all").then(data => {
					this.tagList = data.body.data.tag
				})
			},
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/driver/search", {
					text: this.search.text,
					status: this.search.status,
					offset: more ? this.driverList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					this.driverList = data.body.data;
				})
			},
			checkValidation() {
				if (String(this.driver.name).length > 0 && String(this.driver.phone).length > 0 && String(this.driver.password).length > 0 && String(this.driver.confirm_password).length > 0) {
					if (String(this.driver.password) == String(this.driver.confirm_password)) {

						if (String(this.driver.password).length > 5) {
							return true;
						} else {
							this.$notification.notify({
								message: "ពាក្យសំងាត់ត្រូវមានចាប់ពី ៦តួរអក្សឡើង។",
								icon: 'error',
								type: 'danger'
							})
						}
					} else {
						this.$notification.notify({
							message: "ពាក្យសំងាត់ និង បញ្ជាក់ពាក្យសំងាត់មិនដូចគ្នា។",
							icon: 'error',
							type: 'danger'
						})
					}
				} else {
					this.$notification.notify({
						message: "ព័ត៌មានមិនគ្រប់ សូមពិនិត្យមើលម្តងទៀត។",
						icon: 'error',
						type: 'danger'
					})
					return false;
				}
			},
			deleteDriver(id) {
				if (String(this.deleteID).length > 0) {
					let id = this.deleteID;
					this.onCancel();
					this.$http.post(this.config.api + "/admin/driver/delete", {
						id: id,
					}).then(res => {
						if (res.body.status == 'success') {

							this.searchHandler();

						}
					})
				} else {
					this.deleteID = id;
					this.deleteDialog = true;
				}
			},
			activate(id, status) {
				let update_status = 'act';
				if (status == 'act') update_status = 'nac';

				this.$http.post(this.config.api + "/admin/driver/activate", {
					id: id,
					status: update_status
				}).then(res => {
					if (res.body.status == 'success') {
						if (update_status == 'act') {
							this.$notification.notify({
								message: "អ្នកដឹកជញ្ជូនត្រូវបានដាក់ឱ្យដំណើរការដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
						} else {
							this.$notification.notify({
								message: "អ្នកដឹកជញ្ជូនត្រូវបានផ្អាកដំណើរការដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
						}
						this.tabName = 'first'
						this.searchHandler();

					}
				})
			},
			postDriver() {
				if (this.checkValidation()) {
					this.$http.post(this.config.api + "/admin/driver/post", {
						driver: this.driver
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify({
								message: "អ្នកដឹកជញ្ជូនត្រូវបានបង្កើតដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.tabName = 'first';
							this.clear();
							this.searchHandler();

						}
					})
				}
			},
			clear() {
				this.driver = {
					valid: false,
					name: "",
					phone: "",
					password: "",
					confirm_password: "",
					note: ""
				}
			},
			onCancel() {
				this.deleteID = "";
				this.deleteDialog = false;
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Drivers/View.vue